module.exports = __webpack_public_path__ + "img/car.9e7ae62d.png";